export class ChatCto {
  firstId: number
  secondId: number
  constructor(id1: number, id2: number) {
    this.firstId = id1
    this.secondId = id2
  }
}
